import { AppDispatch } from 'redux/store';

import { findFeaturedPrompts, findPrompts } from '../redux/actions/promptActions';

export const fetchPromptsUtil = async (dispatch: AppDispatch, featured: boolean) => {
  await dispatch(findPrompts());
  if (featured) {
    await dispatch(findFeaturedPrompts());
  }
};
